import { IGetOrdemCompraCanceladoStatusUseCase } from "../../../presentation/useCases/read/get_ordem_compra_cancelado_status_use_case";
import { OrdemCompraCanceladoStatus } from "../../models/ordem_compra_cancelado_status";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraCanceladoStatusUseCase
 */

export class GetOrdemCompraCanceladoStatusUseCase implements IGetOrdemCompraCanceladoStatusUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraCanceladoStatus(
    idOrdemCompra: number | undefined,
  ): Promise<OrdemCompraCanceladoStatus> {
    if (idOrdemCompra === undefined) throw new Error('Falha ao obter id de ordem de compra!');
    var result = await this.repository.getOrdemCompraCanceladoStatus(idOrdemCompra);
    if (result === null) throw new Error('Falha ao buscar dados de ordem de compra!');
    return result;
  }
}
